/** NOTE: this is essentially a completely redundent component,
 *  The reason this exists is so we don't have to explain to Graphics
 *  why the <Container /> Component is capitalized and <section /> is
 *  lower case. rrogers - 2019-04-01 */

const section = (props) => <section {...props} />

export default section